module.exports = __webpack_public_path__ + "img/rown.dc6bb995.png";